import { render } from "./CustomFormField.vue?vue&type=template&id=cfcbf78e"
import script from "./CustomFormField.vue?vue&type=script&lang=js"
export * from "./CustomFormField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__